import { memo } from 'react'

import SimonSaysPage, { TEST_ID } from './SimonSays'

const SimonSays = memo(SimonSaysPage)

export { TEST_ID }

export default SimonSays
